import React, { Component } from "react"

class UVNResize extends Component {
    componentDidMount() { this.updateHeightParent(); }
    componentDidUpdate() { this.updateHeightParent(); }
    updateHeightParent() {
	    function inIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        }
        /**
         * @name gatsby_init_redirect Initilize all links specified on selector query
         * @param {String} url URL to redirect the parent container page.
         */
        function gatsby_init_redirect(selector)
        {
            var links = document.querySelectorAll(selector);
            for (let i = 0; i < links.length; i++) {
                var _link = links[i];
                _link.addEventListener("click", function (etv){
                    gatsby_redirect(this.href);
                });
                //var curr_href = _link.getAttribute("href");
                //_link.setAttribute("href", 'javascript:gatsby_redirect("' + curr_href + '");');
            }
        }
        
        window.addEventListener("load", function load(event){
            if(window.onGatsbyUtilLoaded){
                window.onGatsbyUtilLoaded(event);
            }
        },false);
        
        if(inIframe() && (window.parent != window && typeof window.postMessage != 'undefined') ) {
            
            window.addEventListener('message', function(e) { 
                switch(e.data.event) {
                    case 'uvn-resize':
                        _gatsby_ifr_resize();
                        break;
                }
            }); 
        
            /**
             * @description Use for resize the parent container height.
             * @param force_height optional param to force height iframe container.
             * @name gatsby_resize
             */
            function gatsby_resize(force_height)
            {
                _gatsby_ifr_resize(force_height);
            }
        
            /**
             * 
             * @param {String} url URL to redirect the parent container page.
             */
            function gatsby_redirect(url)
            {
                _gatsby_ifr_redirect(url);
            }
        
            /**
             * 
             * @param {String} url_css URL of stylesheet file.
             */
            function gatsby_load_css(url_css)
            {
                var __idframe = get_gatsby_iframe_param();
                if(__idframe == undefined || __idframe == null) return;
                var message = {
                    event: 'uvn-load-css',
                    'gatsby_iframe_id': __idframe,
                    url_css: url_css
                };
                window.parent.postMessage(message, '*');
            }
            
            /**
             * @description Use for resize the parent container height.
             * @name gatsby_anchor
             * @param {int} value for the scrollTop
             */
            function gatsby_anchor(id){
                _gatsby_ifr_anchor(id);
            }
            
            function _gatsby_ifr_resize(force_height)
            {
                var __idframe = get_gatsby_iframe_param();
                force_height = force_height == undefined ? document.documentElement.offsetHeight : force_height
                if(__idframe == undefined || __idframe == null) return;
                var message = {
                    event: 'uvn-resize',
                    'gatsby_iframe_id': __idframe,
                    height: force_height
                };
                window.parent.postMessage(message, '*');
            }
        
            function _gatsby_ifr_redirect(url)
            {
                var __idframe = get_gatsby_iframe_param();
                if(__idframe == undefined || __idframe == null) return;
                var message = {
                    event: 'uvn-redirect',
                    'gatsby_iframe_id': __idframe,
                    url: url
                };
                window.parent.postMessage(message, '*');
            }
        
            function _gatsby_ifr_anchor(id)
            {
                var __idframe = get_gatsby_iframe_param();
                if(__idframe == undefined || __idframe == null) return;
                var message = {
                    event: 'uvn-anchor',
                    'gatsby_iframe_id': __idframe,
                    id: id
                };
                window.parent.postMessage(message, '*');
            }
        
            function get_gatsby_iframe_param() 
            {
                var parameterName = 'gatsby_iframe_id';
                var result = null,
                    tmp = [];
                location.search
                    .substr(1)
                    .split("&")
                    .forEach(function (item) {
                      tmp = item.split("=");
                      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
                    });
                return result;
            }
            (function (window) {
                
                var last = +new Date();
                var delay = 100; // default delay
            
                // Manage event queue
                var stack = [];
            
                function callback() {
                    var now = +new Date();
                    if (now - last > delay) {
                        for (var i = 0; i < stack.length; i++) {
                            stack[i]();
                        }
                        last = now;
                    }
                }
            
                // Public interface
                var _gatsby_onDomChange = function (fn, newdelay) {
                    if (newdelay) delay = newdelay;
                    stack.push(fn);
                };
            
                // Naive approach for compatibility
                function naive() {
            
                    var last = document.getElementsByTagName('*');
                    var lastlen = last.length;
                    var timer = setTimeout(function check() {
            
                        // get current state of the document
                        var current = document.getElementsByTagName('*');
                        var len = current.length;
            
                        // if the length is different
                        // it's fairly obvious
                        if (len != lastlen) {
                            // just make sure the loop finishes early
                            last = [];
                        }
            
                        // go check every element in order
                        for (var i = 0; i < len; i++) {
                            if (current[i] !== last[i]) {
                                callback();
                                last = current;
                                lastlen = len;
                                break;
                            }
                        }
            
                        // over, and over, and over again
                        setTimeout(check, delay);
            
                    }, delay);
                }
            
                //
                //  Check for mutation events support
                //
            
                var support = {};
            
                var el = document.documentElement;
                var remain = 3;
            
                // callback for the tests
                function decide() {
                    if (support.DOMNodeInserted) {
                        window.addEventListener("DOMContentLoaded", function () {
                            if (support.DOMSubtreeModified) { // for FF 3+, Chrome
                                el.addEventListener('DOMSubtreeModified', callback, false);
                            } else { // for FF 2, Safari, Opera 9.6+
                                el.addEventListener('DOMNodeInserted', callback, false);
                                el.addEventListener('DOMNodeRemoved', callback, false);
                            }
                        }, false);
                    } else if (document.onpropertychange) { // for IE 5.5+
                        document.onpropertychange = callback;
                    } else { // fallback
                        naive();
                    }
                }
            
                // checks a particular event
                function test(event) {
                    el.addEventListener(event, function fn() {
                        support[event] = true;
                        el.removeEventListener(event, fn, false);
                        if (--remain === 0) decide();
                    }, false);
                }
            
                // attach test events
                if (window.addEventListener) {
                    test('DOMSubtreeModified');
                    test('DOMNodeInserted');
                    test('DOMNodeRemoved');
                } else {
                    decide();
                }
            
                // do the dummy test
                var dummy = document.createElement("div");
                el.appendChild(dummy);
                el.removeChild(dummy);
            
                // expose
                window._gatsby_onDomChange = _gatsby_onDomChange;
            })(window);
        
            _gatsby_onDomChange(function(){ 
                _gatsby_ifr_resize();
            });
            setTimeout(function (){
                _gatsby_ifr_resize();
            }, 3000);
        }
        else {
            /**
             * 
             * @param {String} url URL to redirect the parent container page.
             */
            function gatsby_redirect(url)
            {
                if(inIframe != undefined){
                    if( inIframe() )
                    {
                        _gatsby_ifr_redirect(url);
                    }
                }
                else 
                {
                    window.location.href = url;
                }
            }
        }
    }
	render() {
        return <div id={`uvn-resize`}></div>;
	}
}

export default UVNResize


// WEBPACK FOOTER //
// ./src/components/uvn-resize.js